import _createForOfIteratorHelper from "/codebuild/output/src455542086/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper";
import _classCallCheck from "/codebuild/output/src455542086/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/codebuild/output/src455542086/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/codebuild/output/src455542086/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/codebuild/output/src455542086/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";
/**
 * @license Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */
import { Command } from 'ckeditor5/src/core.js';
/**
 * The image type command. It changes the type of a selected image, depending on the configuration.
 */
var ImageTypeCommand = /*#__PURE__*/function (_Command) {
  _inherits(ImageTypeCommand, _Command);
  var _super = _createSuper(ImageTypeCommand);
  /**
   * @inheritDoc
   *
   * @param modelElementName Model element name the command converts to.
   */
  function ImageTypeCommand(editor, modelElementName) {
    var _this;
    _classCallCheck(this, ImageTypeCommand);
    _this = _super.call(this, editor);
    _this._modelElementName = modelElementName;
    return _this;
  }
  /**
   * @inheritDoc
   */
  _createClass(ImageTypeCommand, [{
    key: "refresh",
    value: function refresh() {
      var editor = this.editor;
      var imageUtils = editor.plugins.get('ImageUtils');
      var element = imageUtils.getClosestSelectedImageElement(this.editor.model.document.selection);
      if (this._modelElementName === 'imageBlock') {
        this.isEnabled = imageUtils.isInlineImage(element);
      } else {
        this.isEnabled = imageUtils.isBlockImage(element);
      }
    }
    /**
     * Executes the command and changes the type of a selected image.
     *
     * @fires execute
     * @param options.setImageSizes Specifies whether the image `width` and `height` attributes should be set automatically.
     * The default is `true`.
     * @returns An object containing references to old and new model image elements
     * (for before and after the change) so external integrations can hook into the decorated
     * `execute` event and handle this change. `null` if the type change failed.
     */
  }, {
    key: "execute",
    value: function execute() {
      var _this2 = this;
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var editor = this.editor;
      var model = this.editor.model;
      var imageUtils = editor.plugins.get('ImageUtils');
      var oldElement = imageUtils.getClosestSelectedImageElement(model.document.selection);
      var attributes = Object.fromEntries(oldElement.getAttributes());
      // Don't change image type if "src" is missing (a broken image), unless there's "uploadId" set.
      // This state may happen during image upload (before it finishes) and it should be possible to change type
      // of the image in the meantime.
      if (!attributes.src && !attributes.uploadId) {
        return null;
      }
      return model.change(function (writer) {
        var _options$setImageSize = options.setImageSizes,
          setImageSizes = _options$setImageSize === void 0 ? true : _options$setImageSize; // Get all markers that contain the old image element.
        var markers = Array.from(model.markers).filter(function (marker) {
          return marker.getRange().containsItem(oldElement);
        });
        var newElement = imageUtils.insertImage(attributes, model.createSelection(oldElement, 'on'), _this2._modelElementName, {
          setImageSizes: setImageSizes
        });
        if (!newElement) {
          return null;
        }
        var newElementRange = writer.createRangeOn(newElement);
        // Expand the previously intersecting markers' ranges to include the new image element.
        var _iterator = _createForOfIteratorHelper(markers),
          _step;
        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var marker = _step.value;
            var markerRange = marker.getRange();
            // Join the survived part of the old marker range with the new element range
            // (loosely because there could be some new paragraph or the existing one might got split).
            var range = markerRange.root.rootName != '$graveyard' ? markerRange.getJoined(newElementRange, true) : newElementRange;
            writer.updateMarker(marker, {
              range: range
            });
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
        return {
          oldElement: oldElement,
          newElement: newElement
        };
      });
    }
  }]);
  return ImageTypeCommand;
}(Command);
export { ImageTypeCommand as default };